import React from 'react'
import { Card, Tabs, Typography } from 'antd'
import ItemPanel from './ItemPanel'
import DocPanel from './DocPanel'
import './index.less'

// 2026-10-22 coder(lq): CLI 能力目录后台配置页（AMS /admin/cliCatalog）。
// 两个页签在页面加载时并发取数（Tab1 条目列表、Tab2 文档列表），避免切到文档页才白屏等待。
export default function CliCatalog() {
    return <main className="cli-catalog-page">
        <header className="cli-catalog-heading">
            <div>
                <Typography.Title level={2}>CLI 能力目录</Typography.Title>
                <Typography.Paragraph type="secondary">
                    维护 lechun-cli 的能力条目与 Markdown 文档：保存即入库生效，
                    CLI 侧最多 24 小时内看到（或 <code>lechun-cli context --refresh</code> 立即刷新）。
                </Typography.Paragraph>
            </div>
        </header>
        <Card>
            <Tabs defaultActiveKey="items" items={[
                { key: 'items', label: '能力条目', children: <ItemPanel /> },
                // forceRender：页面加载即挂载文档页签并拉取文档列表，与条目列表并发。
                { key: 'docs', label: '文档', forceRender: true, children: <DocPanel /> },
            ]} />
        </Card>
    </main>
}
